// extracted by mini-css-extract-plugin
module.exports = {"input-button":"checkbox-button__input-button___CnCAJ"};